import React from 'react';
import OrderModalItem from 'shared/OrderModalItem';
import { ISowDataListItem } from '@EngagementsSowData/sowData.model';
import { orderActionsItemTooltip } from 'pages/WirelineEngagements/WirelineEngagementsTables/constants';
import { OrderActions } from 'pages/WirelineEngagements/WirelineEngagementsTables/wirelineEngagementsTables.model';

interface IOrderItemProps {
  order: ISowDataListItem
}

const OrderItem: React.FC<IOrderItemProps> = ({
  order,
}) => {
  const {
    customerLocation, product, provideContractDatetime,
  } = order;

  const tooltipTitle = orderActionsItemTooltip[OrderActions.REQUEST_CONTRACTS];

  return (
    <OrderModalItem
      product={product}
      tooltipTitle={tooltipTitle}
      location={customerLocation}
      accepted={!!provideContractDatetime}
      withTooltip={!!provideContractDatetime}
    />
  );
};

export default OrderItem;
